// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__Gi7Rk","content":"ManualTimeModal_content__1aSRF"};